// extracted by mini-css-extract-plugin
export var activityContainer = "_jw-0";
export var typingIndicatorContainer = "_jw-1";
export var typingIndicatorDot = "_jw-2";
export var wave = "_jw-3";